import { render, staticRenderFns } from "./product-relations-list.vue?vue&type=template&id=1c4b57fe&scoped=true&"
import script from "./product-relations-list.vue?vue&type=script&lang=js&"
export * from "./product-relations-list.vue?vue&type=script&lang=js&"
import style0 from "./product-relations-list.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./product-relations-list.vue?vue&type=style&index=1&id=1c4b57fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4b57fe",
  null
  
)

export default component.exports